<template>
  <div>
    <ContentHeader />
    <div class="content-container">
      <FavItemList item-type="menu" />
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import FavItemList from './components/favourite-item-list'

export default {
  name: 'menu-favourite',
  components: {
    ContentHeader,
    FavItemList
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
